import React, { Component } from "react";

import Styles from "components/open/LegacyFooter.module.scss";
import { Container } from "components/grid/Container";
import { Row } from "components/grid/Row";
import { Col } from "components/grid/Col";

import Logo from "assets/img/glambox.png";

export class LegacyFooter extends Component {
  render () {
    return (
      <div className={Styles["footer"]}>
        <Container>
          <div className={Styles["footer__container"]}>
            <a href={"https://glambox.com.br"} className={Styles["footer__logo"]}>
              <img src={Logo} alt={""}/>
            </a>

            <div className={Styles["footer__fill"]}/>

            <ul className={Styles["footer__social"]}>
              <li>
                <a href={"https://www.facebook.com/glambox.br"} target={"_blank"}>
                  <i className={"fab fa-facebook"}/>
                </a>
              </li>
              <li>
                <a href={"https://www.youtube.com/user/glamboxbrasil"} target={"_blank"}>
                  <i className={"fab fa-youtube"}/>
                </a>
              </li>
              <li>
                <a href={"https://www.instagram.com/glamboxbrasil/"} target={"_blank"}>
                  <i className={"fab fa-instagram"}/>
                </a>
              </li>
            </ul>
          </div>
          <Row>
            <Col xs={6} md={3}>
              <ul className={Styles["footer__menu"]}>
                  <li>
                    <a href="https://glambox.com.br/glambox/parcerias">Parcerias</a>
                  </li>
                  <li>
                    <a href="https://glambox.com.br/shopping">Produtos</a>
                  </li>
                  <li>
                    <a href="http://glamstar.com.br">Glamstar</a>
                  </li>
              </ul>
            </Col>
            <Col xs={6} md={3}>
              <ul className={Styles["footer__menu"]}>
                <li>
                  <a href="https://glambox.com.br/glambox/ajuda">Central de Ajuda</a>
                </li>
                <li>
                  <a href="https://glambox.com.br/glambox/ler/10/política-de-privacidade">Política de Privacidade</a>
                </li>
                <li>
                  <a href="https://glambox.com.br/glambox/ler/9/termos-e-condições-de-uso">Termos e condições de uso</a>
                </li>
              </ul>
            </Col>
            <Col xs={12} md={6}>
              &nbsp;
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
